import { useState, useEffect, PureComponent} from "react";
import "./PublicCollections.css";
import { PublicCollectionsCard } from "./PublicCollectionsCard";
import { PublicCollectionsCover } from "./PublicCollectionsCover";
import { PublicCollection } from "winslow-core"
import { apiGetPublicCollection, apiGetPublicCollections, apiRequestPublicCollection } from "../../services/PublicCollectionService";
import { useNavigate, useParams } from "react-router-dom";
import { toastFail, toastSuccess } from "../../config";
import toast from "react-hot-toast";
import AISidebarAsk from "../ai/AISidebarAsk";
import { PublicCollectionsHeader } from "./PublicCollectionsHeader";
import { ModalRequestCollection } from "./ModalRequestCollection";

type PublicCollectionsProps = {
}

export const PublicCollections = ({ }: PublicCollectionsProps) => {

    const params = useParams();
    const navigate = useNavigate();


    const [publicCollections, setPublicCollections] = useState<PublicCollection[] | undefined>(undefined);
    const [publicCollection, setPublicCollection] = useState<PublicCollection | undefined>(undefined);

    const [aiResponseSaveId, setAiResponseSaveId] = useState<string | undefined>(undefined);
    const [question, setQuestion] = useState<string | null>(null);

    useEffect(() => {
        (async () => {
            if (params && params.publicCollectionId) {
                const pc = await apiGetPublicCollection(params.publicCollectionId);

                if (pc) {
                    setPublicCollection(pc);
                    setPublicCollections(undefined);
                } else {
                    toast("Cannot find public collection", toastFail);
                }
            } else {
                // we don't have root page anymore, bounce it back
                window.location.href = "https://usewinslow.com/";

                // const pcs = await apiGetPublicCollections();

                // if (pcs) {
                //     setPublicCollections(pcs);
                //     setPublicCollection(undefined);
                // }
            }
        })();
    }, [params]);

  

    console.log("Public Collections: ", publicCollections);
    console.log("Public Collection: ", publicCollection);

    return (
        <div id="public-collections">
            {/* <PublicCollectionsCover 
                title={publicCollection ? publicCollection.sourceUrl : undefined}
                minimize={publicCollection ? true : false}
            /> */}
            <PublicCollectionsHeader 
                title={publicCollection ? `Winslow Public Collection: ${publicCollection.title}` : undefined}
            />

            {/* {publicCollections &&
                <div className="public-collections-grid">
                    {publicCollections.map((collection, index) => (
                        <PublicCollectionsCard key={index} publicCollection={collection} />
                    ))}
                    <PublicCollectionsCard key="request" />
                </div>
            } */}
            {publicCollection &&
                <div className="public-collection">
                    {/* <PublicCollectionsCard publicCollection={publicCollection} /> */}
                    {/* ask repl */}
                    {/* <div 
                        className="public-collection-breadcrumbs"
                    >
                        <span onClick={()=> navigate("/public/public-collections")}>Home&nbsp;</span>
                        {">"}
                        <span onClick={()=> window.location.reload()}>&nbsp;{publicCollection.title}</span>
                    </div> */}
                    <div className="public-collection-ai-container">
                        <AISidebarAsk
                            collectionId={publicCollection.collectionId}
                            aiResponseSaveId={aiResponseSaveId}
                            queryStringQuestion={question}
                            hideContext={true}
                            collectionName={publicCollection.sourceUrl}
                            hideQuickReplies={true}
                            subtitle={`Search ${publicCollection.sourceUrl} for policy information`}
                        />
                    </div>
                    
                </div>
            }   

            
            
        </div>

        
    )
}